import { Form, Formik } from 'formik';
import { useEffect, useState } from 'react';
import useSWR from 'swr';
import { useDispatch } from 'react-redux';
import { queryParams } from '@shared/commonFunctions';
import { LoaderBackdrop } from '@shared/components/LoaderBackdrop';
import { Modal } from '@shared/components/modals/Modal';
import { SERVICES } from '@shared/constants/apiConfig';
import { CommonButtonWrapper } from '@styles/CommonStyles';
import { CancelButton, SaveButton } from '@shared/inputs/Buttons';
import { setLastCommentsRefresh } from '@store/reducers/contactManagerSlice';
import { ICriticalFundDelay, IDelayFile, IDelays, IDelaysModalProps, IFundDelay } from '../interfaces';
import { requestSaveDelay } from '../queries';
import { DelaysForm } from './DelaysForm';

export const DelaysModal = ({ openDelayModalPosition, handleClose }: IDelaysModalProps) => {
  const params = queryParams();
  const dispatch = useDispatch();
  const [loading, setLoading] = useState(false);
  const [selectedFundDelay, setSelectedFundDelay] = useState<string[]>([]);
  const [selectedDelayFile, setSelectedDelayFile] = useState<string[]>([]);
  const [selectedCriticalFundDelay, setSelectedCriticalFundDelay] = useState<string[]>([]);
  const { data: delayData } = useSWR<IDelays>(`${SERVICES.DEAL}/deals/${params.dealId}/delay`);

  useEffect(() => {
    const fundDelays =
      delayData?.fundDelay.filter((item: IFundDelay) => item.isDelay).map((i: IFundDelay) => i.userId) || [];
    setSelectedFundDelay(fundDelays);

    const delayFiles =
      delayData?.delayFile.filter((item: IDelayFile) => item.isDelayFile).map((i: IDelayFile) => i.userId) || [];
    setSelectedDelayFile(delayFiles);

    const criticalFundDelays =
      delayData?.criticalFundDelay.filter((item: ICriticalFundDelay) => item.isCriticalDelay).map((i: ICriticalFundDelay) => i.userId) || [];
      setSelectedCriticalFundDelay(criticalFundDelays);
  }, [delayData]);

  const handleSubmit = async(data: IDelays) => {
    const fundDelay: IFundDelay[] = data.fundDelay.map((element: IFundDelay) => {
      const obj: IFundDelay = { ...element, isDelay: data.selectedFundDelay.includes(element.userId) };
      return obj;
    });
    const delayFile: IDelayFile[] = data.delayFile.map((element: IDelayFile) => {
      const obj: IDelayFile = { ...element, isDelayFile: data.selectedDelayFile.includes(element.userId) };
      return obj;
    });
    const criticalFundDelay: ICriticalFundDelay[] = data.criticalFundDelay.map((element: ICriticalFundDelay) => {
      const obj: ICriticalFundDelay = { ...element, isCriticalDelay: data.selectedCriticalFundDelay.includes(element.userId) };
      return obj;
    });
    setLoading(true);
    await requestSaveDelay({ ...data, fundDelay, delayFile, criticalFundDelay });
    dispatch(setLastCommentsRefresh(new Date().toISOString()));
    setLoading(false);
    handleClose();
  };
  return (
    <Modal
      hideBackdrop
      hideCloseIcon
      resetPosition={openDelayModalPosition}
      open={!!openDelayModalPosition}
      marginTop="15px"
      dialogWidth="502px" 
      onClose={handleClose}
    >
      <>
        <LoaderBackdrop open={!delayData} />
        <Formik
          enableReinitialize
          initialValues={{ ...delayData, selectedFundDelay, selectedDelayFile, selectedCriticalFundDelay } as IDelays}
          onSubmit={handleSubmit}
        >
          {(props) => (
            <Form>
              <DelaysForm delayData={props.values} />
              <CommonButtonWrapper>
                <CancelButton onClick={handleClose} />
                <SaveButton  disabled={loading}/>
              </CommonButtonWrapper>
            </Form>
          )}
        </Formik>
      </>
    </Modal>
  );
};
